<template>
  <v-layout justify-space-between>
    <v-flex xs6>
      <div class='title'>
        <a :href='rec.uspstflink' target='_blank'>{{rec.name}}</a>
      </div>
    </v-flex>
    <v-flex xs6>
      <v-chip
        class="white--text ml-0"
        color="#bbb"
        label
        small
      >
      <span class='font-weight-black'>{{rec.grade}}</span>
      </v-chip>
      <v-chip
        class="white--text ml-0"
        color="#bbb"
        label
        small
      >
      <span>{{rec.releaseDate}}</span>
      </v-chip>
      <v-chip
        class="white--text ml-0"
        color="#bbb"
        label
        small
      >
      {{rec.type}}
      </v-chip>
    </v-flex>
  </v-layout>
</template>
<script>
  export default {
    props:[
      'rec'
    ],
    data: () => ({

    }),
    created: function(){

    },
    mounted: function() {
    }
  };
</script>
<style scoped>
a, a:hover {
  text-decoration: none;
  color: #333;
  /* font-size: 1.2rem; */
}
.uspstfgrade {
  border: 1px solid #bbb;
  background-color:#bbb;
  text-align: center;
}
.v-chip__content {
  padding: 0px 2px;
}

</style>
